import {
  type SensitiveType,
  sensitiveTypeValidator,
} from '@framework/engine/schema/widgets/repository/inputs/common/SensitiveDataTypeConfigComponent.tsx';
import { yup } from '@framework/validation/initYup.ts';

export const OmissisDirectiveSchema: yup.ObjectSchema<IOmissisDirective> = yup
  .object({
    enabled: yup
      .boolean()
      .required()
      /** NB Di default un campo è _incluso_ e _visibile_ (non omissis) */
      .default(false)
      .label('Abilita omissis'),
    sensitiveType: sensitiveTypeValidator.nonNullable(),
  })
  .noUnknown();

export interface IOmissisDirective {
  enabled: boolean;
  /**
   * Tipo di dati sensibili del campo: sensibili | personali | nessuno
   */
  sensitiveType?: SensitiveType;
}
